import { Component, Input, OnInit } from '@angular/core';
import { Validators, UntypedFormBuilder } from '@angular/forms';
import { LendersService } from '../../shared/services/lenders.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/shared/services/toast.service';

@Component({
  selector: 'app-lender-details',
  templateUrl: './lender-details.component.html',
  styleUrls: ['./lender-details.component.scss']
})
export class LenderDetailsComponent implements OnInit {

  @Input() lenderId?: number;

  newLender: boolean = true;
  updatingLender: boolean = false;

  lenderDetails = this.fb.group({
    id: null,
    name: ['', Validators.required],
    isActive: [true]
  }, { });

  constructor(private fb: UntypedFormBuilder,

    private lenderService: LendersService,
    public activeModal: NgbActiveModal,
    private toastService: ToastService) {
  }

  ngOnInit(): void {
    if(this.lenderId !== undefined && this.lenderId !== null){
      this.newLender = false;

      this.lenderService.lenderDetails(this.lenderId).subscribe(result => {
        this.lenderDetails.patchValue(result);
      });
    }
    else{
      this.lenderDetails.controls["isActive"].patchValue(true);
    }
  }

  saveLender(){

    this.updatingLender = true;

    this.lenderService.updateLender(this.lenderDetails.value).subscribe(response => {


      this.activeModal.close(true);
      this.updatingLender = false;

      }, (error : any) => {

        var errorMessage = "Update Failed";
        if(error.error !== null && error.error.message !== undefined)
        {
          errorMessage = error.error.message;
        }

        this.updatingLender = false;
        this.toastService.error(errorMessage);


      });
  }

  addLender(){

    this.updatingLender = true;

    this.lenderService.addLender(this.lenderDetails.value).subscribe(response => {

      this.activeModal.close(true);
      this.updatingLender = false;


      }, error => {


        var errorMessage = "Creation Failed";
        if(error.error !== null && error.error.message !== undefined)
        {
          errorMessage = error.error.message;
        }

        this.toastService.error(errorMessage);
    });
  }

}
